import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  logo: {
    width: '164px',
    height: '50px !important',
    margin: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(5, 2),
    },
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    padding: theme.spacing(5, 2),
  },
  title: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(30),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
}))
